import { useEffect, FC, useState } from 'react';
import styles from './globalPageLoader.module.scss';
import { Loading, AnimationProps } from 'uikit/suspense/Loading';
import Lottie from 'react-lottie-player';
import { Loader as animationData } from 'assets/animations/loadin_book';

const animation: AnimationProps = {
  size: 88,
  element: <Lottie animationData={animationData} style={{ width: 88, height: 88 }} play={true} loop={true} />,
};

export const GlobalPageLoader: FC<{ children: (fallback: JSX.Element) => React.ReactNode }> = ({ children }) => {
  const [activeLoadingSources, setActiveLoadingSources] = useState(0);

  const incrementLoadingSource = () => {
    setActiveLoadingSources((prev) => prev + 1);
  };

  const decrementLoadingSource = () => {
    setActiveLoadingSources((prev) => Math.max(prev - 1, 0));
  };

  return (
    <>
      <div
        style={{
          opacity: activeLoadingSources > 0 ? 1 : 0,
          pointerEvents: activeLoadingSources > 0 ? 'auto' : 'none',
        }}
        className={styles.sharedPageLoading}
        aria-hidden={activeLoadingSources === 0}
      >
        <Loading
          animation={animation}
          containerClassName={styles.container}
          loading={activeLoadingSources > 0}
          testId={'global-page-loader'}
        />
      </div>
      {children(
        <LoadingBridge
          incrementLoadingSource={incrementLoadingSource}
          decrementLoadingSource={decrementLoadingSource}
        />,
      )}
    </>
  );
};

const LoadingBridge: FC<{ incrementLoadingSource: () => void; decrementLoadingSource: () => void }> = ({
  incrementLoadingSource,
  decrementLoadingSource,
}) => {
  useEffect(() => {
    incrementLoadingSource();
    return () => {
      decrementLoadingSource();
    };
  }, [decrementLoadingSource, incrementLoadingSource]);

  return <div />;
};
